// The surfaces the pages repeat: a bordered white card, and the light
// header of a list (a group of tasks, its skeleton).
export const CARD_CLASS = 'rounded-lg border border-gray-100 bg-white';
export const LIST_HEADER_CLASS = 'bg-[#fcfcfc] px-4 py-3';
// The header of a group in such a list: small grey capitals and its count.
export const LIST_GROUP_HEADER_CLASS = `${LIST_HEADER_CLASS} text-xs font-medium uppercase leading-4 tracking-[0.2px] text-gray-500`;

// Actions that stay out of sight until their row (a `group`) is hovered or
// holds the keyboard focus, so that a list reads as text; always shown on a
// screen without hover (a tablet), where nothing would reveal them.
export const HOVER_ROW_CLASS = 'group';
export const HOVER_REVEAL_CLASS =
  'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 focus-within:opacity-100 [@media(hover:none)]:opacity-100 transition-opacity';

// The cascade a list's rows come in with: each fades up 30 ms after the one
// above it, capped so the bottom of a long page does not wait for the top.
export const ROW_CASCADE_CLASS = 'motion-safe:animate-fadeUp';
export const rowCascadeDelay = (index) => ({ animationDelay: `${Math.min(index, 9) * 30}ms` });
